import React from "react";
import { ReactComponent as EpicLogo } from "../../assets/logos/ehr-epic.svg";
import { ReactComponent as AthenaLogo } from "../../assets/logos/ehr-athenahealth.svg";
import { ReactComponent as CentricityLogo } from "../../assets/logos/ehr-centricity.svg";
import { ReactComponent as AllscriptsLogo } from "../../assets/logos/ehr-allscripts.svg";
import { ReactComponent as EClinicalWorksLogo } from "../../assets/logos/ehr-eclinicalworks.svg";

const logoContainerStyle = "h-full flex items-center justify-center";

const EHRLogos = [
  <div key="epic" className={`${logoContainerStyle} w-60 pt-0.5`}>
    <EpicLogo />
  </div>,
  <div key="athena" className={`${logoContainerStyle} w-64 pb-1.5`}>
    <AthenaLogo />
  </div>,
  <div key="centricity" className={`${logoContainerStyle} w-64 pb-1 pl-1`}>
    <CentricityLogo />
  </div>,
  <div key="allscripts" className={`${logoContainerStyle} w-64`}>
    <AllscriptsLogo />
  </div>,
  <div key="eclinical" className={`${logoContainerStyle} w-64 pb-1 pl-1`}>
    <EClinicalWorksLogo />
  </div>,
  <div key="epic2" className={`${logoContainerStyle} w-60 pt-0.5`}>
    <EpicLogo />
  </div>,
  <div key="athena2" className={`${logoContainerStyle} w-64 pb-1.5`}>
    <AthenaLogo />
  </div>,
  <div key="centricity2" className={`${logoContainerStyle} w-64 pb-1 pl-1`}>
    <CentricityLogo />
  </div>,
];

const Integrate = () => {
  return (
    <div className="px-5 lg:px-10 pb-14 lg:pb-30 bg-navy rounded-b -mb-1">
      <div className="w-full max-w-full lg:max-w-7xl mx-auto lg:border-t border-white/10 pt-10">
        <div className="w-full max-w-[80vw] lg:max-w-4xl mx-auto flex flex-col items-center lg:grid grid-cols-2-left gap-4 lg:gap-10">
          <p className="text-xs text-white uppercase font-bold">
            Integrate with your EHR
          </p>
          <div className="h-24 lg:h-32 w-full overflow-hidden relative">
            <div className="flex w-fit h-full items-center flex-none whitespace-nowrap animate-marquee">
              {EHRLogos.map((logo) => logo)}
            </div>
            <div className="absolute top-0 w-full h-full bg-navy-gradient" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrate;
